export const promisedCanvasToBlob = (canvas: HTMLCanvasElement, type: string = 'image/jpeg'): Promise<Blob> => {
  return new Promise<any>((resolve, reject) => {
    canvas.toBlob(blob => resolve(blob), type)
  })
}
